import { useMutation } from '@apollo/client'
import { SetupTestSessionPayment, SetupTestSessionPaymentVariables } from '../../types'
import { SETUP_TEST_SESSION_PAYMENT } from './operations'

export const useSetupTestSessionPayment = () =>
  useMutation<SetupTestSessionPayment, SetupTestSessionPaymentVariables>(SETUP_TEST_SESSION_PAYMENT)
